import { lighten, Button as MUIButton, buttonClasses as MUIButtonClasses, styled, } from '@mui/material';
const Button = styled(MUIButton)(({ theme, color: selectedColor }) => {
    const color = selectedColor || 'primary';
    return {
        borderRadius: theme.shape.borderRadius / 2,
        fontFamily: theme.typography.fontFamily,
        lineHeight: '20.57px',
        [`&.${MUIButtonClasses.disabled}`]: {
            color: lighten(theme.palette[color].main, 0.6),
            [`&.${MUIButtonClasses.contained}`]: {
                backgroundColor: lighten(theme.palette[color].main, 0.6),
                color: lighten(theme.palette.getContrastText(theme.palette[color].main), 0.6),
            },
            [`&.${MUIButtonClasses.outlined}`]: {
                borderColor: lighten(theme.palette[color].main, 0.6),
            },
        },
        [`&.${MUIButtonClasses.sizeSmall}`]: {
            fontSize: theme.typography['uikit-button2'].fontSize,
            fontWeight: theme.typography['uikit-button2'].fontWeight,
            lineHeight: theme.typography['uikit-button2'].lineHeight,
            paddingInline: theme.spacing(2),
            paddingBlock: theme.spacing(1.25),
        },
        [`&.${MUIButtonClasses.sizeMedium}`]: {
            fontSize: theme.typography['uikit-button1'].fontSize,
            fontWeight: theme.typography['uikit-button1'].fontWeight,
            lineHeight: theme.typography['uikit-button1'].lineHeight,
            paddingInline: theme.spacing(2.5),
            paddingBlock: theme.spacing(1.5),
        },
        [`&.${MUIButtonClasses.outlined}, &.${MUIButtonClasses.text}`]: {
            '&:hover': {
                backgroundColor: lighten(theme.palette[color].main, 0.9),
            },
        },
        [`&.${MUIButtonClasses.outlined}`]: {
            borderWidth: 2,
            borderColor: theme.palette[color].main,
            [`&.${MUIButtonClasses.sizeSmall}`]: {
                paddingInline: theme.spacing(1.75),
                paddingBlock: theme.spacing(1),
            },
            [`&.${MUIButtonClasses.sizeMedium}`]: {
                paddingInline: theme.spacing(2.25),
                paddingBlock: theme.spacing(1.25),
            },
        },
    };
});
export default Button;
